{
  "alert": "Figyelmeztetés",
  "dismiss": "Elutasítás"
}